import request from "_private/utils/request";

export function FetchFindMonitorReportAndChart(data) {
    return request({
        url: "/report/MonitorInfo/findMonitorReportAndChart",
        method: "post",
        data
    });
}

// 企业在线率排行列表
export function FetchFindComparyOnlineByPage(data) {
    return request({
        url: "/report/companyOnlineRateRanking/findByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}

/**
 * 企业在线率排行列表导出
 * @param {*} data
 */
export function exportListByComparyOnLine(data) {
    return request({
        url: "/base/compary/findByPage",
        method: "post",
        data
    });
}

// 区域湿度在线率
export function FetchFindAreaHumOnlineByPage(data) {
    return request({
        url: "/base/compary/findByPage",
        method: "post",
        data
    });
}
